import commonMapping from "@/mapping/common";
const ap_fixed_ip_enable_list = [
  { value: "0", config: "0", label: "dyn_get_dns", id: "enable_dynamic_ip_setting" },
  { value: "1", config: "1", label: "fix_dns", id: "enable_fixed_ip_setting" },
];
const bridge_sec_type_list = [
  {
    value: "Wireless Network(2.4GHz b/g/n/ax)",
    config: "2g",
    label: "Wireless Network (2.4GHz b/g/n/ax)",
  },
  { value: "Wireless Network(5GHz a/n/ac/ax)", label: "wlan_network_ac_mark", config: "5g" },
];
const bridge_wl_security_type_list = [
  { value: "None", config: "None", label: "sec_off", id: "security_disable" },
  { value: "WPA-Personal", config: "WPA-Personal", label: "sec_wpa", id: "security_wpa" },
  { value: "WPA2-Personal", config: "WPA2-Personal", label: "sec_wpa2", id: "security_wpa2" },
];

const bridge_wla_security_type_list = [
  { value: "None", config: "None", label: "sec_off", id: "security_an_disable" },
  { value: "WPA2-Personal", config: "WPA2-Personal", label: "sec_wpa2", id: "security_an_wpa2" },
];

const operation_type_list = [
  { value: "router", config: "router", label: "rae_rm" },
  { value: "ap", config: "ap", label: "ap_mode" },
  { value: "bridge", config: "bridge", label: "bridge_mode" },
];

export const rae = {
  operation_type: operation_type_list,
  ap_fixed_ip_enable: ap_fixed_ip_enable_list,
  /**bridg page */
  bridge_fixed_ip_enable: commonMapping.intToBoolean,
  bridge_fixed_dns_enable: commonMapping.intToBoolean,
  /**bridge wireless page */
  bridge_sec_type: bridge_sec_type_list,
  bridge_wl_security_type: bridge_wl_security_type_list,
  bridge_wla_security_type: bridge_wla_security_type_list,
};

export default rae;
